const BILLING_ACCOUNT_INTERVALS = {
  weekly: "WEEKLY_TEAM_SCENARIO",
  monthly: "MONTHLY_TEAM_SCENARIO",
};

export default BILLING_ACCOUNT_INTERVALS;
